import { LucideIcon } from 'lucide-react';

interface ProcessStepProps {
  stepNumber: number;
  title: string;
  description: string;
  icon: LucideIcon;
  isLast?: boolean;
}

const ProcessStep = ({ 
  stepNumber, 
  title, 
  description, 
  icon: Icon, 
  isLast = false 
}: ProcessStepProps) => {
  return (
    <div className="relative flex flex-col items-start group">
      {/* Timeline Line - Vertical */}
      {!isLast && (
        <div className="absolute right-[1.9rem] top-16 w-0.5 h-[calc(100%+3rem)] bg-gray-200 z-0"></div>
      )}
      
      {/* Content Container */}
      <div className="relative z-10 flex items-start gap-6 w-full">
        {/* Icon and Number Container */}
        <div className="flex-shrink-0 flex flex-col items-center">
          {/* Icon Box */}
          <div className="w-16 h-16 bg-gray-100 flex items-center justify-center transition-all duration-300 group-hover:bg-black relative">
            <Icon className="w-8 h-8 text-gray-800 group-hover:text-white transition-colors duration-300" strokeWidth={1.5} />
            
            {/* Step Number Badge */}
            <div className="absolute -top-2 -left-2 w-7 h-7 bg-black rounded-full flex items-center justify-center shadow-md">
              <span className="text-xs font-bold text-white">{stepNumber}</span>
            </div>
          </div>
        </div>

        {/* Text Content */}
        <div className="flex-1 pt-2">
          <h3 className="text-xl font-semibold mb-2 text-gray-900">{title}</h3>
          <p className="text-gray-600 text-sm leading-relaxed">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default ProcessStep;
